export default "__VITE_ASSET__b0970f1f__"